import React, { useMemo, useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './App.css';
import { useSelector, useDispatch } from 'react-redux';
import { routerFormatter, shareSystemLayout } from '@/utils/routerForm'
import { type AppDispatch } from '@/store/index'
import { setCurrentMenu } from '@/store/user/userMenu'

function App() {
  const dispatch = useDispatch<AppDispatch>()
  const isLoggedIn = useSelector((state: any) => {
    return !!state.user.accessToken
  });
  const menu = useSelector((state: any) => state.menu.menu);

  const routes = useMemo(() => {
    return routerFormatter(isLoggedIn, menu);
  }, [isLoggedIn, menu]);
  const routerRoutes = useMemo(() => shareSystemLayout(routes), [routes]);
  const router = useMemo(() => createBrowserRouter(routerRoutes), [routerRoutes]);

  useEffect(() => {
    const pureMenu = routes.map((r: any) => {
      return {
        path: r.path,
        handle: {
          title: r.handle?.title
        },
        children: r.children?.map((c: any) => ({
          path: c.path,
          id: c.id,
          handle: {
            title: c.handle?.title,
            path: c.handle?.path,
            group: c.handle?.group,
          },
        })),
      }
    });
    dispatch(setCurrentMenu(pureMenu));
  }, [dispatch, routes]);

  return (
    <RouterProvider router={router} />
  );
}

export default App;
